import React, { useEffect, useRef } from "react";
import insertScript from "helpers/insert-script";

const TrustedShopsWidget = () => {
  const scriptContainerRef = useRef(null);

  useEffect(() => {
    if (scriptContainerRef.current) {
      const existingScript = document.getElementById("trusted-shops-widget-script");
      if (!existingScript) {
        insertScript(
          scriptContainerRef.current,
          "//widgets.trustedshops.com/js/X97B6BCDC260F2BC600BA3A1ED8E3178E.js",
          "trusted-shops-widget-script",
          false,
          false,
          {
            "data-desktop-y-offset": "0",
            "data-mobile-y-offset": "0",
            "data-desktop-disable-reviews": "false",
            "data-desktop-enable-custom": "false",
            "data-desktop-position": "left",
            "data-desktop-custom-width": "156",
            "data-desktop-enable-fadeout": "false",
            "data-disable-mobile": "false",
            "data-disable-trustbadge": "false",
            "data-mobile-custom-width": "156",
            "data-mobile-disable-reviews": "false",
            "data-mobile-enable-custom": "false",
            "data-mobile-position": "left",
            "data-color-scheme": "os-default",
            "charset": "UTF-8"
          }
        );
      }
    }

    return () => {
      const scriptElement = document.getElementById("trusted-shops-widget-script");
      if (scriptElement) {
        scriptElement.parentNode.removeChild(scriptElement);
      }
    };
  }, []);

  return (
    <div ref={scriptContainerRef} id="trusted-shops-widget-root"></div>
  );
};

export default TrustedShopsWidget;
